import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealNOIField({ value, error, setValue, setError }) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='noi-helper-text'
          label='NOI'
          id='noi'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='noi-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='noi-helper-text'>
            Enter the projected Net Operation Income
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
